export enum TaskMetric {
  Outstanding = '# of Outstanding Tasks',
  Completed = '# of Completed Tasks',
  AverageCompletionTime = 'Avg. Time to Complete',
  CancelledTask = '# of Cancelled Tasks',
}
